<template>
  <div class="index">
    <transition :name="transitionName">
      <router-view />
    </transition>
    <van-tabbar class="my-tab" route active-color="#824614" v-if="isShow">
      <van-tabbar-item replace to="/home">
        <van-icon size="22" class="iconfont icon-home_tab" class-prefix='icon' slot="icon"></van-icon>
        <span>首页</span>
      </van-tabbar-item>
      <van-tabbar-item replace to="/category">
        <van-icon size="22" class="iconfont icon-cate" class-prefix='icon' slot="icon"></van-icon>
        <span>分类</span>
      </van-tabbar-item>
      <van-tabbar-item replace to="/mine">
        <van-icon size="22" class="iconfont icon-me" class-prefix='icon' slot="icon"></van-icon>
        <span>我的</span>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import Button from "@m/vant/Button";
import TabBar from "@m/vant/TabBar";
import Icon from "@m/vant/Icon";
export default {
  data() {
    return {
      transitionName: "slide-right",
      icon: {
        home_tab: "home_tab",
        icon_cate: "icon-cate",
        icon_me: "icon-me"
      },
      isShow: true
    };
  },

  mixins: [Button, TabBar, Icon],
  watch: {
    $route(val) {
      console.log(val);
      const isBack = this.$router.isBack;
      if (isBack) {
        // 设置动画名称
        this.transitionName = "slide-left";
      } else {
        this.transitionName = "slide-right";
      }
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.index {
  height: 100%;
}
</style>